import { Anchor, Stack, Text } from '@mantine/core'

import { useGlobalState } from '@/hooks/useGlobalState'
import { getChannelDeeplinkUrl } from '@/utils/sponsors'

import { LinkField, SettingCard } from './AccessControls'
import { copy } from './copy'

const IMPLEMENTATION_KIT_URL = 'https://sidekickplatform.com/resources/implementation-kit/'

export function WebSetupCard() {
  const { authenticationStore, configStore } = useGlobalState()
  const channelUrl = getChannelDeeplinkUrl(configStore.authBaseUrl, authenticationStore.user?.sponsorId)

  return (
    <SettingCard title={copy.webSetup.title} description={copy.webSetup.description}>
      <Stack gap="lg">
        <div>
          <Text fw={600} mb="xs">
            {copy.webSetup.linkTitle}
          </Text>
          <Text size="sm" mb="sm">
            {copy.webSetup.linkBody}
          </Text>
          {channelUrl && <LinkField value={channelUrl} label="channel URL" />}
        </div>

        <div>
          <Text fw={600} mb="xs">
            {copy.webSetup.buttonTitle}
          </Text>
          <Text size="sm">
            {copy.webSetup.buttonBefore}{' '}
            <Anchor href={IMPLEMENTATION_KIT_URL} target="_blank" rel="noopener noreferrer">
              {copy.webSetup.buttonLink}
            </Anchor>{' '}
            {copy.webSetup.buttonAfter}
          </Text>
        </div>
      </Stack>
    </SettingCard>
  )
}
